import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { SharedModule } from '../../shared/shared.module';
import { EmpresasEmpComponent } from './views/administrador/empresas/empresas.component';
import { CrearEmpleadoComponent } from './views/administrador/ce-empleado/ce-empleado.component';
import { HomeEmpComponent } from './views/administrador/home-emp/home-emp.component';
import { CrearCargosComponent } from './views/administrador/crear-cargos/crear-cargos.component';
import { ReportesComponent } from './views/administrador/reportes/reportes.component';
import { EmpTercerosRoutingModule } from './emp-terceros-routing.module';
import { ReportesEmpComponent } from './views/administrador/reportes-emp/reportes-emp.component';
import { UploadEmpleadoComponent } from './views/administrador/upload-empleado/upload-empleado.component';
import { ControlEmpresaComponent } from './views/administrador/control-empresa/control-empresa.component';
import { EliminarEmpleadoComponent } from './views/administrador/eliminar-empleado/eliminar-empleado.component';
import { CrearHistorialComponent } from './views/administrador/crear-historial/crear-historial.component';
import { HomeSstmaComponent } from './views/sstma/home-sstma/home-sstma.component';
import { AprRechDocumentacionComponent } from './views/sstma/apr-rech-documentacion/apr-rech-documentacion.component';
import { RechazadosDocumentacionComponent } from './views/sstma/rechazados-documentacion/rechazados-documentacion.component';
import { ReporteHorasComponent } from './views/administrador/reporte-horas/reporte-horas.component';
import { AprobadosDocumentacionComponent } from './views/sstma/aprobados-documentacion/aprobados-documentacion.component';
import { DesvinculacionComponent } from './views/administrador/desvinculacion/desvinculacion.component';
import { MantenerMarcacionesComponent } from './views/administrador/mantener-marcaciones/mantener-marcaciones.component';
import { SeleccionRoutingModule } from './seleccionlf/seleccion-routing.module';
import { SeleccionCargasModule } from './seleccionlf/seleccion-cargas.module';
import { SeguridadComponent } from './garita/seguridad/seguridad.component';
import { ConfirmacionComponent } from './garita/confirmacion/confirmacion.component';



@NgModule({
    declarations: [
      HomeEmpComponent,
      EmpresasEmpComponent,
      CrearCargosComponent,
      CrearEmpleadoComponent,
      ReportesComponent,
      ReportesEmpComponent,
      UploadEmpleadoComponent,
      ControlEmpresaComponent,
      EliminarEmpleadoComponent,
      CrearHistorialComponent,
      HomeSstmaComponent,
      AprRechDocumentacionComponent,
      RechazadosDocumentacionComponent,
      ReporteHorasComponent,
      AprobadosDocumentacionComponent,
      DesvinculacionComponent,
      MantenerMarcacionesComponent,
      SeguridadComponent,
      ConfirmacionComponent
      // RegistroComidaComponent
    ],
    exports: [
      HomeEmpComponent,
      EmpresasEmpComponent,
      CrearCargosComponent,
      CrearEmpleadoComponent,
      ReportesComponent,
      ReportesEmpComponent,
      // RegistroComidaComponent
    ],
    imports: [
      CommonModule,
      EmpTercerosRoutingModule,
      RouterModule,
      FormsModule,
      ReactiveFormsModule,
      SharedModule,
      SeleccionCargasModule,
      AgGridModule.withComponents([LfsaBotonEditarGridComponent]),
    ]
  })
export class EmpTercerosModule {}